import {bootstrapApplication} from "@angular/platform-browser";
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from "@angular/router";
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from "@ionic/angular/standalone";

import {routes} from "./app/app.routes";
import {AppComponent} from "./app/app.component";
import {IonicStorageModule} from "@ionic/storage-angular";
import {enableProdMode, importProvidersFrom} from "@angular/core";
import {provideHttpClient, withInterceptors} from "@angular/common/http";

import {defineCustomElements} from "@ionic/pwa-elements/loader";
import {environment} from "./environments/environment";
import {authInterceptor} from "./app/interceptors/auth.interceptor";
import {addApiKeyInterceptor} from "./app/interceptors/auth.interceptor";
import {appConfig} from './app/app.config';

defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig);
